import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Warning from '@material-ui/icons/Warning';
import { TextField, Box } from '@material-ui/core';
import Dialog from './Dialog';
import { Alert } from '@material-ui/lab';
import InputText from './form-input-inline';


class DeleteDialog extends Component {
    state = {
        deleteCode: "",
        errors:{
            deleteCode:""
        }
    }
    handleChange = (e) => {
        this.setState({
            deleteCode: e.target.value
        })
    }
    handleSubmit = () => {
        // Password verification is now handled by the backend
        // Pass the password to the parent component
        if(this.props.noPassword){
            // If no password required, just submit
            this.props.handleSubmit()
        } else {
            // Pass the password to the backend for verification
            this.props.handleSubmit(this.state.deleteCode)
        }
    }
    render() {
        return (
            <Dialog 
                disableBackdropClick
                block={this.props.block || this.props.open}
                close={this.props.close}
                title={`Supprimer ${this.props.title}`}
                submitAction={this.handleSubmit}
                disabledSubmit={this.props.disabled}
                submitTitle="Supprimer"
            >
                <Box p={1}>
                    {!this.props.noPassword &&
                        <InputText
                            type="password"
                            name="deleteCode" 
                            value={this.state.deleteCode} 
                            label="Code de supression" 
                            placeholder="Code de supression" 
                            required
                            error={this.state.errors.deleteCode} 
                            onChange={this.handleChange}
                        />
                    }
                </Box>
                <Alert severity="warning">
                    Attention : Cette action sera irréversible
                </Alert>

                {/* <Box p={1}>
                    <Button variant="contained" onClick={this.handleSubmit} color="secondary" disabled={this.props.disabled}>
                        Supprimer
                    </Button>
                    <Button onClick={this.props.close} color="secondary">
                        Annuler
                    </Button>
                </Box> */}
            </Dialog>
        );
    }
}

export default DeleteDialog;